import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { jsPDF } from 'jspdf';
import logo from "assets/img/logoNotaria11Bga.png";


// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  Container,
  Row,
  Col,
  FormGroup,
  Button,
  Input,
  InputGroupText,
  InputGroup,
  Table,
  Form,
} from "reactstrap";

const selectOptions = [
  { value: "", label: " Elija tipo de acto", isDisabled: true },
  { value: "1", label: "Compra Venta" },
  { value: "2", label: "Compra Venta e hipoteca con particulares" },
  { value: "3", label: "Compra Venta e Hipoteca con entidades financieras" },
  { value: "4", label: "Hipoteca" },
  { value: "5", label: "Cancelación de hipoteca con particulares" },
  { value: "6", label: "Cancelación de hipoteca con entidades financieras" },
  { value: "7", label: "Matrimonio Civil en la notaría" },
  { value: "8", label: "Matrimonio Civil a domicilio" },
  { value: "9", label: "Sucesiones" },
  { value: "10", label: "Liquidación de sociedad conyugal" },
];

const ACTOS_MAP = {
  "1": "5d7efbd8-65b1-4edb-ae78-c120c38e7a29",
  "2": "529e1559-d146-4456-9670-7b412f2b343c",
  "3": "529e1559-d146-4456-9670-7b412f2b343c",
  "4": "9773adf4-796f-455b-9416-7fa98f287715",
  "5": "287302b9-6780-4709-8f2f-2d2edaf4fe31",
  "6": "287302b9-6780-4709-8f2f-2d2edaf4fe31",
  "7": "15b4aa9a-e168-4571-94cb-6cc3743348c5",
  "8": "c789b97d-9940-46f4-921b-9d3711bd84a3",
  "9": "b8792e4e-3ad2-4df0-afde-ab75b735ec31",
  "10": "48036ace-a20d-4d02-bdfc-e62bebb2748e",
  hipoteca_particulares: "9773adf4-796f-455b-9416-7fa98f287715",
  hipoteca_entidades: "9756339f-792e-4941-a91b-c80c0dfb8f51",
};


function CotizadorCore({ onCotizar, serviciosIniciales = [] }) {
  // ---------- LÓGICA ORIGINAL (SIN CAMBIOS) ----------
  const [tipoEscritura, setTipoEscritura] = React.useState("");
  const [nombreActo, setNomreActo] = React.useState("");
  const [valorCuantia, setValorCuantia] = React.useState("");
  const [valorHipoteca, setValorHipoteca] = React.useState("");
  const [tDerechos, setTotalDerechos] = React.useState(0);
  const [tCotizacion, setCotizacion] = React.useState(0);
  const [tFondo, setFondo] = React.useState(0);
  const [tSuper, setSuper] = React.useState(0);
  const [tRete, setRete] = React.useState(0);
  const [tIva, setIva] = React.useState(0);
  const [showHipoteca, setHipoteca] = React.useState(false);
  const [showCuantía, setCuantia] = React.useState(false);
  const [showDerechos, setDerechos] = React.useState(false);
  const [showStatico, setStatico] = React.useState(false);
  const [servicios, setServicios] = React.useState(serviciosIniciales);
  const [checkedRete, setCheckedRete] = React.useState(true);
  const [service_disabled] = React.useState([1]);
  const [actosDerechos, setActosDerechos] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const notaria = useSelector((state) => state.notaria.notaria);

  React.useEffect(() => {
    setServicios(serviciosIniciales);
  }, [serviciosIniciales]);

  // Helpers (sin cambios)
  const getNumeroSeguro = (val) => {
    const n = Number(val);
    return Number.isFinite(n) ? n : 0;
  };

  const normalizarTexto = (val = "") => val.toString().trim().toLowerCase();

  const obtenerValor = (origen, campos = []) => {
    for (let i = 0; i < campos.length; i++) {
      const v = origen?.[campos[i]];
      if (v !== undefined && v !== null) return v;
    }
    return undefined;
  };

  const aplicarRespuestaCotizacion = (respuestaApi) => {
    // ... (TODO EL CÓDIGO ORIGINAL DE ESTA FUNCIÓN SIN MODIFICAR)
    const envelope = respuestaApi?.data || {};
    const payload = envelope?.data || envelope;
    const actosRespuesta = Array.isArray(payload?.actos) ? payload.actos : [];
    const actoCotizado = actosRespuesta[0] || {};
    const resumenActo = actoCotizado?.resumen || {};
    const resumenGeneral = payload?.resumen_general || {};
    const detalleActo = Array.isArray(actoCotizado?.detalle)
      ? actoCotizado.detalle
      : [];

    const iva = getNumeroSeguro(
      obtenerValor(resumenGeneral, ["iva"]) || obtenerValor(resumenActo, ["iva"])
    );
    const superRegistro = getNumeroSeguro(
      obtenerValor(resumenGeneral, ["super"]) || obtenerValor(actoCotizado, ["super"])
    );
    const fondo = getNumeroSeguro(
      obtenerValor(resumenGeneral, ["fondo"]) || obtenerValor(actoCotizado, ["fondo"])
    );
    const retencion = getNumeroSeguro(
      obtenerValor(resumenGeneral, ["retencion"]) || obtenerValor(resumenActo, ["retencion"])
    );
    const total = getNumeroSeguro(
      obtenerValor(resumenGeneral, ["total"]) || obtenerValor(resumenActo, ["total"])
    );

    const derechosDetalle =
      detalleActo.find((i) => normalizarTexto(i?.tarifa_tipo) === "derecho_notarial") ||
      detalleActo.find((i) => normalizarTexto(i?.concepto) === "derechos notariales");
    const derechosCant = getNumeroSeguro(obtenerValor(derechosDetalle || {}, ["cantidad"])) || 1;
    const derechosTotal = getNumeroSeguro(obtenerValor(derechosDetalle || {}, ["total"]));
    const derechosUnit = getNumeroSeguro(
      obtenerValor(derechosDetalle || {}, ["valor_unitario", "valor_unit", "valor"])
    );
    const derechos = derechosUnit || (derechosTotal > 0 ? Math.round(derechosTotal / derechosCant) : 0);

    const esMultiActo = actosRespuesta.length > 1;

    if (esMultiActo) {
      setActosDerechos(
        actosRespuesta.map((acto, idx) => {
          const det = Array.isArray(acto?.detalle) ? acto.detalle : [];
          const dd =
            det.find((i) => normalizarTexto(i?.tarifa_tipo) === "derecho_notarial") ||
            det.find((i) => normalizarTexto(i?.concepto) === "derechos notariales");
          const cant = getNumeroSeguro(obtenerValor(dd || {}, ["cantidad"])) || 1;
          const tot = getNumeroSeguro(obtenerValor(dd || {}, ["total"]));
          const unit = getNumeroSeguro(obtenerValor(dd || {}, ["valor_unitario", "valor_unit", "valor"]));
          const der = unit || (tot > 0 ? Math.round(tot / cant) : 0);
          const nombreA = obtenerValor(acto?.acto || {}, ["nombre"]) || `Acto ${idx + 1}`;
          return { nombre: `Derechos Notariales - ${nombreA}`, cantidad: cant, valor_unit: der };
        })
      );
    } else {
      setActosDerechos([]);
    }

    setIva(iva);
    setSuper(superRegistro);
    setFondo(fondo);
    setRete(retencion);
    setCotizacion(total);
    setTotalDerechos(derechos);

    setServicios((prev) =>
      prev.map((s) => {
        if (Number(s.id) === 1) {
          return esMultiActo
            ? { ...s, cant_predet: 0, valor_unit: 0 }
            : { ...s, cant_predet: derechosCant, valor_unit: derechos };
        }
        return s;
      })
    );

    setStatico(true);
  };

  const updateCantidad = (id, value) => {
    setServicios((prev) =>
      prev.map((item) =>
        item.id.toString() === id.toString()
          ? { ...item, cant_predet: getNumeroSeguro(value) }
          : item
      )
    );
  };

  const selectTipoEscritura = (event) => {
    setTipoEscritura(event.value);
    setStatico(false);
    setActosDerechos([]);

    switch (event.value) {
      case "1": setHipoteca(false); setCuantia(true); break;
      case "2": setHipoteca(true); setCuantia(true); break;
      case "3": setHipoteca(true); setCuantia(true); break;
      case "4": setHipoteca(true); setCuantia(false); break;
      case "5": setHipoteca(true); setCuantia(false); break;
      case "6": setHipoteca(false); setCuantia(false); break;
      case "7": setHipoteca(false); setCuantia(false); break;
      case "8": setHipoteca(false); setCuantia(false); break;
      case "9": setHipoteca(false); setCuantia(true); break;
      case "10": setHipoteca(false); setCuantia(true); break;
      default: setHipoteca(false); setCuantia(false);
    }

    setDerechos(true);

    const found = selectOptions.find((o) => o.value === event.value);
    if (found) setNomreActo(found.label);
  };

  const CheckedRetencion = (val) => {
    setCheckedRete(val);
    if (val) {
      setCotizacion((prev) => prev + tRete);
    } else {
      setCotizacion((prev) => prev - tRete);
    }
  };

  const cotizar = async () => {
    if (!tipoEscritura || typeof onCotizar !== "function") return;

    setLoading(true);

    const serviciosAdicionales = servicios
      .filter(
        (s) => !service_disabled.includes(Number(s.id)) && getNumeroSeguro(s.cant_predet) > 0
      )
      .map((s) => ({ id: Number(s.id), cantidad: getNumeroSeguro(s.cant_predet) }));

    let payload;

    if (tipoEscritura === "2" || tipoEscritura === "3") {
      payload = {
        actos: [
          {
            acto_id: ACTOS_MAP["1"],
            cuantia: getNumeroSeguro(valorCuantia),
            aplica_retencion: checkedRete,
            aplica_exentos: false,
            servicios_adicionales: serviciosAdicionales,
          },
          {
            acto_id:
              tipoEscritura === "2"
                ? ACTOS_MAP["hipoteca_particulares"]
                : ACTOS_MAP["hipoteca_entidades"],
            cuantia: getNumeroSeguro(valorHipoteca),
            aplica_retencion: checkedRete,
            aplica_exentos: false,
            servicios_adicionales: [],
          },
        ],
      };
    } else {
      payload = {
        actos: [
          {
            acto_id: ACTOS_MAP[tipoEscritura] || tipoEscritura,
            cuantia: getNumeroSeguro(valorCuantia) + getNumeroSeguro(valorHipoteca),
            aplica_retencion: checkedRete,
            aplica_exentos: false,
            servicios_adicionales: serviciosAdicionales,
          },
        ],
      };
    }

    try {
      const respuesta = await onCotizar(payload);
      aplicarRespuestaCotizacion(respuesta);
    } catch (error) {
      console.error("Error al cotizar:", error.response?.data || error.message);
    } finally {
      setLoading(false);
    }
  };

  const formatear = (num) => {
    while (num.toString().indexOf(".") !== -1) {
      num = num.toString().replace(".", "");
    }
    num = num.toString();
    let resultado = "";
    for (var j, i = num.length - 1, j = 0; i >= 0; i--, j++)
      resultado = num.charAt(i) + (j > 0 && j % 3 === 0 ? "." : "") + resultado;
    return resultado;
  };

  const getDataUri = (url) => {
    return new Promise((resolve) => {
      var image = new Image();
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = this.naturalWidth;
        canvas.height = this.naturalHeight;
        var ctx = canvas.getContext("2d");
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        canvas.getContext("2d").drawImage(this, 0, 0);
        resolve(canvas.toDataURL("image/jpeg"));
      };
      image.src = url;
    });
  };

  const pdf = async () => {
    let vertical = 0;
    let horizontal = 0;
    var doc = new jsPDF({
      orientation: "p",
      unit: "mm",
      format: "letter",
    });
    doc.setFontSize(16);
    doc.setFont(undefined, "bold");
    doc.text(String(notaria.nombre_notaria || ""), 20, 25);
    doc.setFontSize(10);
    vertical = 30;
    horizontal = 20;
    doc.setFont(undefined, "normal");
    doc.text(String(notaria.notario || ""), horizontal, vertical);
    doc.text("Nit. " + String(notaria.identificacion || ""), horizontal, vertical + 5);
    doc.text(String(notaria.direccion || ""), horizontal, vertical + 10);
    doc.text(String(notaria.telefono || ""), horizontal, vertical + 15);
    doc.text(String(notaria.regimen || ""), horizontal, vertical + 20);
    doc.line(horizontal, vertical + 23, 200, vertical + 23);
    doc.line(horizontal, vertical + 24, 200, vertical + 24);

    var urlLogo = await getDataUri(logo);
    doc.addImage(urlLogo, "JPEG", 130, 20, 60, 25);

    vertical = 60;
    doc.setFontSize(16);
    doc.setFont(undefined, "bold");
    doc.text("Cotización Previa", 100, vertical);
    doc.setFontSize(12);
    doc.setFont(undefined, "normal");
    doc.text("Acto:", horizontal + 10, vertical + 10);
    doc.text(String(nombreActo || ""), horizontal + 23, vertical + 10);
    var f = new Date();
    doc.text(
      "Fecha: " + f.getDate() + "/" + (f.getMonth() + 1) + "/" + f.getFullYear(),
      horizontal + 130,
      vertical + 10
    );
    if (showCuantía) {
      doc.text("Cuantía:", horizontal + 35, vertical + 20);
      doc.text("$" + formatear(valorCuantia), horizontal + 55, vertical + 20);
    }
    if (showHipoteca) {
      doc.text("Hipoteca:", horizontal + 95, vertical + 20);
      doc.text("$" + formatear(valorHipoteca), horizontal + 115, vertical + 20);
    }

    doc.setFont(undefined, "bold");
    vertical = 90;
    horizontal = 10;
    doc.text("Servicio", horizontal + 20, vertical);
    doc.text("Cantidad", horizontal + 80, vertical, "center");
    doc.text("Precio. Uni", horizontal + 110, vertical);
    doc.text("Total", horizontal + 156, vertical);

    doc.setFont(undefined, "normal");
    vertical = 100;
    horizontal = 30;

    if (actosDerechos.length > 0) {
      actosDerechos.forEach((d) => {
        doc.text(String(d.nombre || "").slice(0, 30), horizontal, vertical);
        doc.text(String(d.cantidad), horizontal + 60, vertical);
        doc.text("$" + formatear(d.valor_unit), horizontal + 110, vertical, "right");
        doc.text("$" + formatear(d.valor_unit * d.cantidad), horizontal + 150, vertical, "right");
        vertical += 5;
      });
      servicios
        .filter((s) => Number(s.id) !== 1)
        .forEach((item) => {
          doc.text(String(item.servicio_name || ""), horizontal, vertical);
          doc.text(String(item.cant_predet), horizontal + 60, vertical);
          doc.text("$" + formatear(item.valor_unit), horizontal + 110, vertical, "right");
          doc.text("$" + formatear(item.valor_unit * item.cant_predet), horizontal + 150, vertical, "right");
          vertical += 5;
        });
    } else {
      servicios.forEach((item) => {
        doc.text(String(item.servicio_name || ""), horizontal, vertical);
        doc.text(String(item.cant_predet), horizontal + 60, vertical);
        doc.text("$" + formatear(item.valor_unit), horizontal + 110, vertical, "right");
        doc.text("$" + formatear(item.valor_unit * item.cant_predet), horizontal + 150, vertical, "right");
        vertical += 5;
      });
    }

    vertical += 10;
    doc.text("Iva:", horizontal + 110, vertical, "right");
    doc.text("$" + formatear(tIva), horizontal + 150, vertical, "right");
    vertical += 5;
    doc.text("Super:", horizontal + 110, vertical, "right");
    doc.text("$" + formatear(tSuper), horizontal + 150, vertical, "right");
    vertical += 5;
    doc.text("Fondo:", horizontal + 110, vertical, "right");
    doc.text("$" + formatear(tFondo), horizontal + 150, vertical, "right");
    vertical += 5;
    if (checkedRete) {
      doc.text("Retención:", horizontal + 110, vertical, "right");
      doc.text("$" + formatear(tRete), horizontal + 150, vertical, "right");
    }

    vertical += 5;
    doc.setFont(undefined, "bold");
    doc.text("Gran Total:", horizontal + 110, vertical, "right");
    doc.text("$" + formatear(tCotizacion), horizontal + 150, vertical, "right");
    doc.setFont(undefined, "normal");

    vertical = 200;
    doc.line(20, vertical, 200, vertical);
    doc.setFontSize(10);
    doc.text("Generado por Sinfony", 85, vertical + 5);
    doc.save("Cotización.pdf");
  };

  return (
        <div style={{ backgroundColor: "#fff", marginTop: "10em",paddingTop:"10em", paddingBottom: "3em" }}>
      <Container>
        {/* Título */}
        <Row>
          <Col className="ml-auto mr-auto text-center" md="12">
            <h1 className="title" style={{ color: "#031425", fontWeight: "bold" }}>
              Cotizador en Línea
            </h1>
            <div style={{ height: "25px" }} />
          </Col>
        </Row>

        {/* Tarjetas superiores: Selector de acto y campos de valor */}
        <Row>
          {/* Columna izquierda: Selección de acto */}
          <Col className="ml-auto mr-auto" lg="6">
            <Card style={{ borderRadius: "15px", border: "1px solid #888888" }}>
              <CardHeader style={{ borderBottom: "1px solid #888888", backgroundColor: "#f8f9fa" }}>
                <h3 className="info-title text-center" style={{ marginTop: "10px" }}>
                  <b>Selecciona el acto</b>
                </h3>
              </CardHeader>
              <CardBody style={{ padding: "20px 30px" }}>
                <FormGroup>
                  <label
                    htmlFor="acto-select"
                    style={{
                      fontWeight: "600",
                      color: "#333",
                      marginBottom: "10px",
                      display: "block",
                    }}
                  >
                    Seleccionar tipo de acto:
                  </label>
                  <Input
                    type="select"
                    id="acto-select"
                    value={tipoEscritura}
                    onChange={(e) => selectTipoEscritura({ value: e.target.value })}
                    style={{
                      borderRadius: "10px",
                      minHeight: "50px",
                      fontSize: "15px",
                      color: tipoEscritura ? "#333" : "#999",
                      border: "1px solid #ccc",
                      padding: "10px 15px",
                      appearance: "none",
                      WebkitAppearance: "none",
                      backgroundImage: "url(\"data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23666'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E\")",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "right 12px center",
                      backgroundSize: "20px",
                      cursor: "pointer",
                    }}
                  >
                    <option value="" disabled style={{ color: "#999" }}>
                      -- Elija el tipo de acto --
                    </option>
                    {selectOptions.map((o) => (
                      <option key={o.value} value={o.value} disabled={o.isDisabled} style={{ color: "#333" }}>
                        {o.label}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </CardBody>
            </Card>
          </Col>

          {/* Columna derecha: Campos de cuantía/hipoteca (si aplica) */}
          {showDerechos && (
            <Col className="ml-auto mr-auto" lg="6">
              <Card
                className="text-center"
                style={{ borderRadius: "15px", border: "1px solid #888888" }}
              >
                <CardHeader style={{ borderBottom: "1px solid #888888", backgroundColor: "#f8f9fa" }}>
                  <h4 className="info-title text-center" style={{ marginTop: "5px" }}>
                    <b>Ingresar el valor:</b>
                  </h4>
                </CardHeader>
                <CardBody>
                  <Form>
                    <Row className="justify-content-center">
                      {showCuantía && (
                        <Col sm="6">
                          <FormGroup>
                            <label>
                              <b>Cuantía</b>
                            </label>
                            <Input
                              id="valor_cuantia"
                              onChange={(e) => setValorCuantia(e.target.value)}
                              type="number"
                              value={valorCuantia}
                              style={{ borderRadius: "8px" }}
                            />
                            <br />
                            <label className="text-center">
                              <b>Valor Cuantía: $ </b>
                              {formatear(valorCuantia)}
                            </label>
                          </FormGroup>
                        </Col>
                      )}
                      {showHipoteca && (
                        <Col sm="6">
                          <FormGroup>
                            <label>
                              <b>Hipoteca</b>
                            </label>
                            <Input
                              id="valor_hipoteca"
                              onChange={(e) => setValorHipoteca(e.target.value)}
                              type="number"
                              value={valorHipoteca}
                              style={{ borderRadius: "8px" }}
                            />
                            <br />
                            <label className="text-center">
                              <b>Valor Hipoteca: $ </b>
                              {formatear(valorHipoteca)}
                            </label>
                          </FormGroup>
                        </Col>
                      )}
                    </Row>
                  </Form>
                  <Button
                    onClick={cotizar}
                    color="info"
                    disabled={loading}
                    style={{ fontSize: "14px", fontWeight: "bold" }}
                  >
                    {loading ? "Cotizando..." : "Cotizar"}
                  </Button>
                </CardBody>
              </Card>
            </Col>
          )}
        </Row>

        {/* Tarjeta de resultados (tabla) */}
        {showStatico && (
          <Row style={{ marginTop: "30px" }}>
            <Col lg="12">
              <Card style={{ borderRadius: "15px", border: "1px solid #888888" }}>
                <CardHeader style={{ borderBottom: "1px solid #888888", backgroundColor: "#f8f9fa" }}>
                  <h2 className="info-title text-center" style={{ marginTop: "20px" }}>
                    <b>Cotización</b>
                  </h2>
                </CardHeader>
                <CardBody>
                  <Table className="text-center" responsive>
                    <thead>
                      <tr>
                        <th style={{ color: "#1c6e38" }}>Servicios</th>
                        <th style={{ color: "#1c6e38" }}>Cantidad</th>
                        <th style={{ color: "#1c6e38" }}>Precio Unitario</th>
                        <th style={{ color: "#1c6e38" }}>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {actosDerechos.length > 0 &&
                        actosDerechos.map((d, idx) => (
                          <tr key={`derecho-${idx}`}>
                            <td>{d.nombre}</td>
                            <td>
                              <Row className="justify-content-center">
                                <Col sm="6">
                                  <FormGroup>
                                    <Input disabled value={d.cantidad} type="number" />
                                  </FormGroup>
                                </Col>
                              </Row>
                            </td>
                            <td>{"$" + formatear(d.valor_unit)}</td>
                            <td>{"$" + formatear(d.valor_unit * d.cantidad)}</td>
                          </tr>
                        ))}
                      {(actosDerechos.length > 0
                        ? servicios.filter((s) => Number(s.id) !== 1)
                        : servicios
                      ).map((item) => (
                        <tr key={uuidv4()}>
                          <td>{item.servicio_name}</td>
                          <td>
                            <Row className="justify-content-center">
                              <Col sm="6">
                                <FormGroup>
                                  <Input
                                    id={item.id.toString()}
                                    disabled={service_disabled.includes(item.id)}
                                    defaultValue={item.cant_predet}
                                    onChange={(e) =>
                                      updateCantidad(e.target.id, e.target.value)
                                    }
                                    type="number"
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                          </td>
                          <td>{"$" + formatear(item.valor_unit)}</td>
                          <td>{"$" + formatear(item.valor_unit * item.cant_predet)}</td>
                        </tr>
                      ))}
                      <tr>
                        <td></td>
                        <td></td>
                        <td>IVA</td>
                        <td>{"$" + formatear(tIva)}</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td>Super</td>
                        <td>{"$" + formatear(tSuper)}</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td>Fondo</td>
                        <td>{"$" + formatear(tFondo)}</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td className="font-weight-normal">
                          <div className="custom-control custom-switch">
                            <input
                              checked={checkedRete}
                              type="checkbox"
                              className="custom-control-input"
                              id="customSwitch1"
                              onChange={(event) => CheckedRetencion(event.target.checked)}
                            />
                            <label className="custom-control-label" htmlFor="customSwitch1">
                              Retención
                            </label>
                          </div>
                        </td>
                        <td>{checkedRete && "$" + formatear(tRete)}</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td>
                          <b>Total Cotización</b>
                        </td>
                        <td>
                          <b>{"$" + formatear(tCotizacion)}</b>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                  <Row>
                    <Col sm="12" className="text-center">
                      <h5 className="info-title text-center" style={{ marginTop: "10px" }}>
                        <b>Nota: </b>
                        <i>
                          Retención <b>SI</b> para Persona Natural y <b>NO</b> para Persona Jurídica.
                        </i>
                      </h5>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "20px" }}>
                    <Col sm="12" className="text-center">
                      <Button onClick={pdf} color="info">
                        <b style={{ fontSize: "14px" }}>Imprimir PDF</b>
                      </Button>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </Container>
    </div>
  );
}

export default CotizadorCore;